import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '@shared/abstract.service';
import { HttpClient } from '@angular/common/http';
import { SERVICES, HTTP_METHODS } from '@root/constant';
import { EncryptionProviderService } from '@shared/encryption.service';

const URL = SERVICES.PUSH_NOTIFICATION.PATH;

@Injectable()
export class PushNotificationService extends AbstractService<any> {
  constructor(
    http: HttpClient,

    encryptionProviderService: EncryptionProviderService
  ) {
    super(http, URL, encryptionProviderService);
    this.encryptionProviderService = encryptionProviderService;
  }

  public create(data: any, headerData: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/save`,
      body: data,
      headers: headerData,
    });
  }

  public realAll(): Observable<any> {
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${SERVICES.PUSH_NOTIFICATIONS.PATH}`,
    });
  }

  public delete(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/delete`,
      body: data,
    });
  }

  public readAllNotificationTags() {
    const url = SERVICES.PUSH_NOTIFICATIONS_TAGS.PATH;
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: {},
    });
  }

  public sendNotification(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/send`,
      body: data,
    });
  }

  public readNotificationHistory(data: any) {
    const url = SERVICES.PUSH_NOTIFICATION.PATH;
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}/senthistory`,
      body: data,
    });
  }
}
